import { useEffect, useState } from 'react';

// compact <640 · medium 640-1023 · full >=1024 (spec §2.4). SSR/jsdom-safe.
const QUERIES = [
  ['full', '(min-width: 1024px)'],
  ['medium', '(min-width: 640px)'],
];

function current() {
  if (typeof window === 'undefined' || !window.matchMedia) return 'full';
  for (const [name, q] of QUERIES) {
    if (window.matchMedia(q).matches) return name;
  }
  return 'compact';
}

export default function useBreakpoint() {
  const [bp, setBp] = useState(current);

  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const lists = QUERIES.map(([, q]) => window.matchMedia(q));
    const onChange = () => setBp(current());
    // Modern path first. Safari only grew MediaQueryList.addEventListener in 14 —
    // older iOS in our browserslist has the deprecated addListener only, and with
    // no fallback the hook silently never updated there: rotate the phone and the
    // layout stayed on whichever tier it happened to mount at.
    lists.forEach((l) => {
      if (l.addEventListener) {
        l.addEventListener('change', onChange);
      } else if (l.addListener) {
        l.addListener(onChange);
      }
    });
    return () =>
      lists.forEach((l) => {
        if (l.removeEventListener) {
          l.removeEventListener('change', onChange);
        } else if (l.removeListener) {
          l.removeListener(onChange);
        }
      });
  }, []);

  return bp;
}
